import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { NotificationSettings, UpdateNotificationSettings } from '../../domain/models/notification-settings.model';
import { INotificationSettingsRepository } from '../../domain/repositories/notification-settings.repository';
import { NotificationSettingsRemoteDatasource } from '../datasources/remote/notification-settings.remote-datasource';
import { NotificationSettingsMapper } from '../mappers/notification-settings.mapper';

@Injectable()
export class NotificationSettingsRepositoryImpl implements INotificationSettingsRepository {
  private readonly datasource = inject(NotificationSettingsRemoteDatasource);
  private readonly mapper = inject(NotificationSettingsMapper);

  public get(organizationId: number): Observable<NotificationSettings> {
    return this.datasource.get(organizationId).pipe(map((dto) => this.mapper.toNotificationSettings(dto)));
  }

  public update(organizationId: number, request: UpdateNotificationSettings): Observable<NotificationSettings> {
    return this.datasource.update(organizationId, this.mapper.toUpdateRequest(request)).pipe(
      map((dto) => this.mapper.toNotificationSettings(dto)),
    );
  }

  public sendTest(organizationId: number): Observable<void> {
    return this.datasource.sendTest(organizationId);
  }
}
